/**
 * @generated SignedSource<<a9e7fe3e99eb06f576f573fec9928b3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView$data = {
  readonly cascadingOption: {
    readonly childOptionValue: {
      readonly value: string | null | undefined;
    } | null | undefined;
    readonly parentOptionValue: {
      readonly value: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly " $fragmentType": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView";
};
export type cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView$key = {
  readonly " $data"?: cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView",
  "selections": [
    {
      "concreteType": "JiraCascadingOption",
      "kind": "LinkedField",
      "name": "cascadingOption",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "parentOptionValue",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "childOptionValue",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraCascadingSelectField"
};
})();

(node as any).hash = "e99135b57678ee49ef5d587f655eb169";

export default node;
